import axios from "axios";
import getAccessToken from "./accessToken";

// const API_URL = "https://api-admin.ashjarspace.com/space-admin/api/v1/";
// const API_URL = "https://workspace-admin.applligentdemo.com/api/v1/organization/";
// const API_URL = "http://127.0.0.1:4000/api/v1/organization/";
const API_URL = "https://workspace-portal-api.tod.com.sa/api/v1/organization/";

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.request.use(
  async (config) => {
    const { token, orgSecretKey, orgCode } = await getAccessToken();
    if (token) {
      config.headers.Authorization = token;
    }
    const language =
      typeof localStorage !== "undefined"
        ? localStorage.getItem("I18N_LANGUAGE")
        : null;
    config.headers["Accept-Language"] = language === "sa" ? "ar" : "en";
    if (orgSecretKey) config.headers["x-org-id"] = orgSecretKey;
    if (orgCode) config.headers["x-org-code"] = orgCode;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

axiosApi.interceptors.request.use(
  async (config) => {
    const token = await getAccessToken();
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export async function get(url, data, config = {}) {
  return await axiosApi
    .get(url, { ...data }, { ...config })
    .then((response) => response.data)
    .catch((err) => {
      const status = err?.response?.status;
      const message = err?.response?.data?.message;

      // if (status === 401) {
      //   window.alert(
      //     "Your account has been blocked by the Super Admin. You have been logged out."
      //   );
      //   window.location.href = "/logout";
      // }

      if ((status === 400 && message) || status === 401) {
        return err.response.data;
      }
    });
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data)
    .catch((err) => {
      const status = err?.response?.status;
      const message = err?.response?.data?.message;

      // if (status === 401) {
      //   window.alert(
      //     "Your account has been blocked by the Super Admin. You have been logged out."
      //   );
      //   window.location.href = "/logout";
      // }

      if (status === 400 && message) {
        return err.response.data;
      }
    });
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data)
    .catch((err) => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data;
      }
    });
}

export async function del(url, data, config = {}) {
  return await axiosApi
    .delete(url, { data: { ...data }, ...config })
    .then((response) => response.data)
    .catch((err) => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data;
      }
    });
}

export async function patch(url, config = {}) {
  return await axiosApi
    .patch(url, { ...config })
    .then((response) => response.data)
    .catch((err) => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data;
      }
    });
}

export async function formDataPost(url, data, config = {}) {
  return axiosApi
    .post(url, data, { ...config }) // Directly pass the FormData object
    .then((response) => response.data)
    .catch((err) => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data;
      }
    });
}

export async function formDataPut(url, data, config = {}) {
  return axiosApi
    .put(url, data, { ...config }) // Directly pass the FormData object
    .then((response) => response.data)
    .catch((err) => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data;
      }
    });
}

export async function formDataPatch(url, data, config = {}) {
  return axiosApi
    .patch(url, data, { ...config }) // Directly pass the FormData object
    .then((response) => response.data)
    .catch((err) => {
      if (err?.response?.status === 400) {
        if (err?.response?.data?.message) return err?.response?.data;
      }
    });
}
